<template>
  <div class="bg auth-screen">
    <div class="pt-100">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title" v-translate:pweb_title_verify_identity="lang">
            Verify Identity
          </h2>
          <div class="card-description">We've sent a six-digit confirmation code to {{ mobileNo }} email.</div>
          <form class="otp_form">
            <div class="form-group otp-input-group">
              <label>Enter Code</label>
              <div class="row">
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_1"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_1'),
                      'is-success': !errors.has('otp_1')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_1"
                    maxlength="1"
                    id="1"
                    v-on:keyup="validatePassKey(1)"
                    required
                    tabindex="-1"
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_2"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_2'),
                      'is-success': !errors.has('otp_2')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_2"
                    maxlength="1"
                    id="2"
                    v-on:keyup="validatePassKey(2)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_3"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_3'),
                      'is-success': !errors.has('otp_3')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_3"
                    maxlength="1"
                    id="3"
                    v-on:keyup="validatePassKey(3)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_4"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_4'),
                      'is-success': !errors.has('otp_4')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_4"
                    maxlength="1"
                    id="4"
                    v-on:keyup="validatePassKey(4)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_5"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_5'),
                      'is-success': !errors.has('otp_5')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_5"
                    maxlength="1"
                    id="5"
                    v-on:keyup="validatePassKey(5)"
                    required
                  />
                </div>
                <div class="col-lg-2 mr-0">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_6"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_6'),
                      'is-success': !errors.has('otp_6')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_6"
                    maxlength="1"
                    id="6"
                    v-on:keyup="validatePassKey(6)"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="success-msg-style" v-if="successMsg">
                {{ successMsg }}
              </div>
              <div class="error-style" v-if="errorMsg">{{ errorMsg }}</div>
              <div v-if="errors.any()">
                <button class="btn btn-primary btn-block" :disabled="!correctOTP">
                  Continue
                </button>
              </div>
              <div v-if="!errors.any()">
                <button type="submit" class="btn btn-primary btn-block" v-on:click.prevent="confirmOTP">
                  Continue
                </button>
              </div>
            </div>
            <div class="footer-links">
              <a v-on:click="resendOTP" v-translate:label_resend_code="lang">Resend code</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import toastr from 'toastr';

const jwtDecode = require("jwt-decode");

export default {
  name: "sendOTP",
  data() {
    return {
      otp_1: "",
      otp_2: "",
      otp_3: "",
      otp_4: "",
      otp_5: "",
      otp_6: "",
      otp: "",
      formErrors: false,
      correctOTP: false,
      successMsg: null,
      errorMsg: null,
      mobileNo: null,
      token: null
    };
  },
  computed: {
    clientVal() {
      return this.$store.getters.appStateClientId;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  mounted() {
    this.mobileNo = this.$route.params.mobile ? `${this.$route.params.mobile} and your` : "your";
    this.token = this.$route.params.token;
  },
  watch: {
    clientVal: {
      handler(val) {
        if (val.clientId) {
          this.sendOtpToMobile();
        }
      }
    }
  },
  methods: {
    sendOtpToMobile() {
      this.$api
        .sendOtpToMobileFact({
          token: this.token
        })
        .then(
          () => {
            this.errorMsg = null;
          },
          error => {
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while sending OTP to mobile";
          }
        );
    },
    incorrectNumber() {
      if (window.localStorage.getItem("thread-token")) {
        this.decoded = jwtDecode(window.localStorage.getItem("thread-token"));
        this.$router.push({
          name: "aboutYou",
          params: {
            userId: this.decoded.id
          }
        });
      }
    },
    confirmOTP() {
      this.otp = this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4 + this.otp_5 + this.otp_6;
      this.$api
        .verifyOtpFact({
          token: this.token,
          otp: this.otp
        })
        .then(
          response => {
            this.correctOTP = true;
            this.errorMsg = null;
            this.successMsg = response.body.message;
            if (window.localStorage.getItem("thread-token")) {
              this.decoded = jwtDecode(window.localStorage.getItem("thread-token"));
              if (this.decoded.userRole === "SystemAdmin") {
                this.$router.push({
                  name: "invite-admins"
                });
              } else {
                this.$router.push({
                  name: "studies"
                });
              }
            } else {
              this.$router.push({
                name: "createPassword"
              });
            }
          },
          error => {
            if (error.status === 409) {
              this.$router.push({
                name: "expire-link"
              });
            }
            this.$store.dispatch("confirmOtpErrorAction", {
              token: this.token,
              otp: this.otp
            });
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while confirming the OTP";
          }
        );
    },
    goToNextPage() {
      if (window.localStorage.getItem("thread-token")) {
        this.decoded = jwtDecode(window.localStorage.getItem("thread-token"));
        if (this.decoded.userRole === "SystemAdmin") {
          this.$router.push({
            name: "invite-admins"
          });
        } else {
          this.$router.push({
            name: "studies"
          });
        }
      } else {
        this.$router.push({
          name: "createPassword"
        });
      }
    },
    validatePassKey(id) {
      if (window.event.keyCode !== 8 && window.event.keyCode !== 46 && id !== 6) {
        window.document.getElementById(id + 1).focus();
      } else if ((window.event.keyCode === 8 || window.event.keyCode === 46) && id !== 1) {
        window.document.getElementById(id - 1).focus();
      }
    },
    resendOTP() {
      this.errorMsg = null;
      this.successMsg = null;
      this.$api
        .sendOtpToMobileFact({
          token: this.token
        })
        .then(
          () => {
            this.successMsg = "Code resent";
          },
          error => {
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while resending the OTP";
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.link-style {
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
}

.error-style {
  font-size: 12px;
  color: #ffa500;
  padding-bottom: 15px;
  text-align: center;
}

.success-msg-style {
  font-size: 12px;
  color: #449d44;
  padding-bottom: 15px;
  text-align: center;
}
</style>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
